export const getResultCountHandler = component => data => {
  const results = data.result;

  let total;
  let result;

  if (results?.bestMatch) {
    const bestMatch =
      Array.isArray(results.bestMatch) ? result.bestMatch : [results.bestMatch];
    total = bestMatch.length;
  }

  if (results.nowPlaying) {
    total += results.nowPlaying.length;
  }

  total += results.results.length;

  component.setState(() => ({ showMoreVisible: total >= 20 }));

  return total;
};
